import React from 'react';
import { Button as MuiButton, makeStyles, Theme } from '@material-ui/core';
import { SearchIcon } from 'asset/images';
import { SearchButtonProps } from 'components/Button/type';

const useStyles = makeStyles((theme: Theme) => ({
  searchButton: {
    height: '40px',
    color: 'rgba(255, 255, 255, 1.0)',
    backgroundColor: 'rgba(202, 90, 150, 1.0)',
    fontWeight: 'bold',
    fontSize: '1.0em',
    borderRadius: 0,

    '&:hover': {
      backgroundColor: 'rgba(202, 90, 150, 0.9)',
    },
  },
  icon: {
    width: '1.2em',
    margin: '0 5px 0 0',
  },
}));

function SearchButton({ onClick }: SearchButtonProps) {
  const classes = useStyles();
  return (
    <MuiButton fullWidth className={classes.searchButton} type="submit" onClick={onClick}>
      <img src={SearchIcon} className={classes.icon}></img>
      검색
    </MuiButton>
  );
}

export default SearchButton;
